import Vue from 'vue';
import _ from 'lodash/fp';

import misfitIds from '@/helpers/misfitIds.js';

// Import Flavor images
import flavorBananaImage from '@/assets/images/flavors/flavor_banana.png';
import flavorBlackRaspberryImage from '@/assets/images/flavors/flavor_black_raspberry.png';
import flavorBluePunchImage from '@/assets/images/flavors/flavor_blue_punch.png';
import flavorBlueberriesImage from '@/assets/images/flavors/flavor_blueberries.png';
import flavorCherryImage from '@/assets/images/flavors/flavor_cherry.png';
import flavorGrapeImage from '@/assets/images/flavors/flavor_grape.png';
import flavorKiwiImage from '@/assets/images/flavors/flavor_kiwi.png';
import flavorLemonImage from '@/assets/images/flavors/flavor_lemon.png';
import flavorLimeImage from '@/assets/images/flavors/flavor_lime.png';
import flavorLycheeImage from '@/assets/images/flavors/flavor_lychee.png';
import flavorMangoImage from '@/assets/images/flavors/flavor_mango.png';
import flavorOrangeImage from '@/assets/images/flavors/flavor_orange.png';
import flavorPineappleImage from '@/assets/images/flavors/flavor_pineapple.png';
import flavorPineappleGreenImage from '@/assets/images/flavors/flavor_pineapple_green.png';
import flavorPomegranateImage from '@/assets/images/flavors/flavor_pomegranate.png';
import flavorStrawberryImage from '@/assets/images/flavors/flavor_strawberry.png';
import flavorWatermelonImage from '@/assets/images/flavors/flavor_watermelon.png';


import merbearLemonBlackRaspberryImage from '@/assets/images/merbear_lemon_black_raspberry.png';
import merbearPineappleOrangeImage from '@/assets/images/merbear_pineapple_orange.png';
import merbearStrawberryBluePunchImage from '@/assets/images/merbear_strawberry_blue_punch.png';
import unisharkKiwiLycheeImage from '@/assets/images/unishark_kiwi_lychee.png';
import unisharkLimeMangoImage from '@/assets/images/unishark_lime_mango.png';
import unisharkPineapplePomegranateImage from '@/assets/images/unishark_pineapple_pomegranate.png';

import merbearQuizOutlineImage from '@/assets/images/merbear_quiz_outline.png';
import unisharkQuizOutlineImage from '@/assets/images/unishark_quiz_outline.png';


const misfitTypeMerbear = 'MER-BEARS';
const misfitTypeUnishark = 'TROPICAL UNI-SHARKS';

function pickRandomObject(arr, obj1, obj2) {
  // console.log('pickRandomObject from:');
  // console.log(arr);
  // console.log('obj1.id:', obj1.id);
  // console.log('obj2.id:', obj2.id);

  let randIndex;
  let found = false;

  while( !found ) {
    randIndex = Math.floor(Math.random() * arr.length);
    if( arr[randIndex].id !== obj1.id && arr[randIndex].label !== obj1.label && arr[randIndex].id !== obj2.id && arr[randIndex].label !== obj2.label ) {
      found = true;

    }
  }

  // console.log('randIndex:', randIndex);

  return arr[randIndex];
}

// initial state
const state = {
  misfits: [
    {
      id: misfitIds.MER_BEAR_ORANGE_PINEAPPLE,
      type: misfitTypeMerbear,
      // name: 'orange + pineapple',
      flavors: [0, 11],
      assetURL: merbearPineappleOrangeImage,
      quizOutlineAssetURL: merbearQuizOutlineImage,
    },
    {
      id: misfitIds.MER_BEAR_LEMON_BLACK_RASPBERRY,
      type: misfitTypeMerbear,
      // name: 'lemon + black raspberry',
      flavors: [14, 2],
      assetURL: merbearLemonBlackRaspberryImage,
      quizOutlineAssetURL: merbearQuizOutlineImage,
    },
    {
      id: misfitIds.MER_BEAR_STRAWBERRY_BLUE_PUNCH,
      type: misfitTypeMerbear,
      // name: 'strawberry + blue punch',
      flavors: [6, 4],
      assetURL: merbearStrawberryBluePunchImage,
      quizOutlineAssetURL: merbearQuizOutlineImage,
    },
    {
      id: misfitIds.UNI_SHARK_PINEAPPLE_POMEGRANATE,
      type: misfitTypeUnishark,
      // name: 'pineapple + pomegranate',
      flavors: [12, 16],
      assetURL: unisharkPineapplePomegranateImage,
      quizOutlineAssetURL: unisharkQuizOutlineImage,
    },
    {
      id: misfitIds.UNI_SHARK_LYCHEE_KIWI,
      type: misfitTypeUnishark,
      // name: 'lychee + kiwi',
      flavors: [17, 9],
      assetURL: unisharkKiwiLycheeImage,
      quizOutlineAssetURL: unisharkQuizOutlineImage,
    },
    {
      id: misfitIds.UNI_SHARK_LIME_MANGO,
      type: misfitTypeUnishark,
      // name: 'lime + mango',
      flavors: [15, 1],
      assetURL: unisharkLimeMangoImage,
      quizOutlineAssetURL: unisharkQuizOutlineImage,
    },
  ],

  // Divide the possible flavors to different color categories so
  possibleFlavors: [
    // orange color
    [
      {
        id: 0,
        label: 'orange',
        assetURL: flavorOrangeImage,
        wrongOverlayOpacity: 0.25,
      },
      {
        id: 1,
        label: 'mango',
        assetURL: flavorMangoImage,
        wrongOverlayOpacity: 0.25,
      },
    ],

    // purple color
    [
      {
        id: 2,
        label: 'black raspberry',
        assetURL: flavorBlackRaspberryImage,
        wrongOverlayOpacity: 0.05,
      },
      {
        id: 3,
        label: 'grape',
        assetURL: flavorBlackRaspberryImage,
        wrongOverlayOpacity: 0.05,
      },
    ],

    // blue color
    [
      {
        id: 4,
        label: 'blue punch',
        assetURL: flavorBluePunchImage,
        wrongOverlayOpacity: 0.1,
      },
      {
        id: 5,
        label: 'blueberries',
        assetURL: flavorBlueberriesImage,
        wrongOverlayOpacity: 0.1,
      },
    ],

    // red color
    [
      {
        id: 6,
        label: 'strawberry',
        assetURL: flavorStrawberryImage,
        wrongOverlayOpacity: 0.0,
      },
      {
        id: 7,
        label: 'cherry',
        assetURL: flavorCherryImage,
        wrongOverlayOpacity: 0.0,
      },
    ],

    // green color
    [
      {
        id: 9,
        label: 'kiwi',
        assetURL: flavorKiwiImage,
        wrongOverlayOpacity: 0.4,
      },
      {
        id: 10,
        label: 'watermelon',
        assetURL: flavorWatermelonImage,
        wrongOverlayOpacity: 0.4,
      },
      {
        id: 11,
        label: 'pineapple',
        assetURL: flavorPineappleGreenImage,
        wrongOverlayOpacity: 0.4,
      },
    ],

    // yellow color
    [
      {
        id: 12,
        label: 'pineapple',
        assetURL: flavorPineappleImage,
        wrongOverlayOpacity: 0.5,
      },
      {
        id: 13,
        label: 'banana',
        assetURL: flavorBananaImage,
        wrongOverlayOpacity: 0.5,
      },
      {
        id: 14,
        label: 'lemon',
        assetURL: flavorLemonImage,
        wrongOverlayOpacity: 0.5,
      },
      {
        id: 15,
        label: 'lime',
        assetURL: flavorLimeImage,
        wrongOverlayOpacity: 0.6,
      },
    ],

    // pink color
    [
      {
        id: 16,
        label: 'pomegranate',
        assetURL: flavorPomegranateImage,
        wrongOverlayOpacity: 0.15,
      },
      {
        id: 17,
        label: 'lychee',
        assetURL: flavorLycheeImage,
        wrongOverlayOpacity: 0.15,
      },
    ],

  ],
}

// getters
const getters = {
  getMisfits(state) {
    return state.misfits;
  },

  getMisfitMerbears(state) {
    return state.misfits.filter(item => (item.type === misfitTypeMerbear));
  },

  getMisfitUnisharks(state) {
    return state.misfits.filter(item => (item.type === misfitTypeUnishark));
  },

  // getMisfitFlavors(state) {
  //
  // },

  getMisfitDisplayLabel: (state, getters) => (id) => {
    let misfit = getters['getMisfitById'](id);
    let flavorOne = getters['getMisfitFlavorById'](misfit.flavors[0]);
    let flavorTwo = getters['getMisfitFlavorById'](misfit.flavors[1]);

    return flavorOne.label + ' + ' + flavorTwo.label;
  },

  // getFruitById: (state, getters) => (id) => {
  //   return state.fruits.find(item => (item.id == id));
  // },

  getMisfitById: (state, getters) => (id) => {
    return state.misfits.find(item => (item.id === id));
  },

  getMisfitFlavorById: (state, getters) => (id) => {
    // state.possibleFlavors.forEach((flavor) => {
    //   console.log(flavor[0].id);
    //   return flavor.find(item => (item.id === id));
    // })
    //
    // return null;

    let foundFlavor = null;

    state.possibleFlavors.forEach((flavors) => {
      // console.log(flavors);

      flavors.forEach((flavor) => {
        if( flavor.id === id ) {
          foundFlavor = flavor;
        }
      })
    })

    return foundFlavor;

    // return state.possibleFlavors[0][0];
  },

  getFlavorOptionsForMisfit: (state, getters) => (id) => {
    // console.log('getFlavorOptionsForMisfit');

    const misfit = getters['getMisfitById'](id);
    const flavorOne = getters['getMisfitFlavorById'](misfit.flavors[0]);
    const flavorTwo = getters['getMisfitFlavorById'](misfit.flavors[1]);
    console.log('flavor 0 id:', misfit.flavors[0]);
    console.log('flavor 1 id:', misfit.flavors[1]);

    let flavorOptions = [];
    let tPossibleFlavors = _.cloneDeep(state.possibleFlavors);

    // console.log('flavors length:', tPossibleFlavors.length);

    for( let i=0; i<tPossibleFlavors.length; i++ ) {
      let flavors = tPossibleFlavors[i];

      for( let j=0; j<flavors.length; j++ ) {
        // console.log('flavors[j].id:', flavors[j].id);
        if( flavors[j].id == misfit.flavors[0] || flavors[j].id == misfit.flavors[1] ) {
          // console.log('match possible flavor, add to flavorOptions');
          flavorOptions.push(flavors[j]);
          tPossibleFlavors.splice(i, 1);
          --i;
        }
      }
    }

    // console.log('after found the id, here are the remaining flavor options');
    // console.log(tPossibleFlavors);

    // let index0 = Math.floor(Math.random() * tPossibleFlavors.length);
    // let flavors = tPossibleFlavors.splice(index0, 1);

    while( tPossibleFlavors.length > 0 ) {
      let index0 = Math.floor(Math.random() * tPossibleFlavors.length);
      let flavors = tPossibleFlavors.splice(index0, 1);

      // console.log('index0:', index0);

      let flavorPicked = pickRandomObject(flavors[0], flavorOne, flavorTwo);

      flavorOptions.push(flavorPicked);

      if( flavorOptions.length >= 5 ) {
        break;
      }
    }

    console.log(flavorOptions);

    // tPossibleFlavors.forEach((flavors) => {
    //
    // });

    return _.shuffle(flavorOptions);
  },
}

// actions
const actions = {

}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
